// Copyright 2025. WebPros International GmbH. All rights reserved.

export const ADMIN_MENU = 'admin-menu';
